import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import PresentationPage from './components/PresentationPage';
import BusinessForm from './components/BusinessForm';
import ServicePage from './components/ServicePage';
import OrderPage from './components/OrderPage';
import GamesPage from './components/GamesPage';
import CookieBanner from './components/CookieBanner';
import { checkPromoCode } from './api';
import SEO from './data/seo.json';

// Title, description and canonical link per page (scripts/prerender.js writes the same into the static HTML)
function setPageMeta(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const page = SEO.pages[path] || SEO.pages['/'];
  document.title = page.title;
  document.querySelector('meta[name="description"]')?.setAttribute('content', page.description);
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = SEO.site.url + (SEO.pages[path] ? path : '/');
}

function App() {
  const [showForm, setShowForm] = useState(false);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  // The router keeps the previous page's scroll position — start each page at the top
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  useEffect(() => { setPageMeta(pathname); }, [pathname]);

  // Ads link to any page with ?cod=XYZ — remember the code for the order page and show it
  const [adPromo, setAdPromo] = useState(null);
  useEffect(() => {
    const code = new URLSearchParams(search).get('cod');
    if (!code) return;
    const clean = code.trim().toUpperCase();
    try { sessionStorage.setItem('dd_promo', clean); } catch { /* storage unavailable */ }
    checkPromoCode({ code: clean, package: 'prezentare', maintenance: false })
      .then(setAdPromo)
      .catch(() => setAdPromo(null));
  }, [search]);

  // Service pages link to "/?demo=true" to open the demo form
  useEffect(() => {
    if (new URLSearchParams(search).get('demo') === 'true') {
      setShowForm(true);
      navigate(pathname, { replace: true });
    }
  }, [search, pathname, navigate]);

  return (
    <>
      <Routes>
        <Route path="/servicii/:slug" element={<ServicePage />} />
        <Route path="/comanda" element={<OrderPage />} />
        <Route path="/joaca" element={<GamesPage />} />
        <Route
          path="/"
          element={
            <PresentationPage onOpenForm={() => setShowForm(true)} />
          }
        />
          }
        />
      </Routes>

      {adPromo && pathname !== '/comanda' && !showForm && (
        <Link to={`/comanda?cod=${encodeURIComponent(adPromo.code)}`} style={{
          position: 'fixed', left: '50%', bottom: 16, transform: 'translateX(-50%)', zIndex: 150,
          display: 'flex', alignItems: 'center', gap: 8, maxWidth: 'calc(100vw - 32px)',
          background: 'rgba(17,18,24,.95)', border: '1px solid #ff79c660', borderRadius: 30,
          padding: '10px 18px', boxShadow: '0 10px 40px rgba(255,121,198,.25)', backdropFilter: 'blur(10px)',
          color: '#f8f8f2', textDecoration: 'none', fontFamily: "'Space Grotesk',sans-serif", fontSize: 13,
          whiteSpace: 'nowrap',
        }}>
          🎁 <span>Cod <b style={{ color: '#ff79c6' }}>{adPromo.code}</b>: {adPromo.label}</span>
          <span style={{ color: '#50fa7b', fontWeight: 700 }}>Comandă →</span>
        </Link>
      )}

      {showForm && (
        <BusinessForm onClose={() => setShowForm(false)} />
      )}

      <CookieBanner />
    </>
  );
}

export default App;
